import cs from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import ComponentSwitcher from 'components/ComponentSwitcher'
import FrameMacStraight from 'components/FrameMacStraight'
import { Text } from 'styles/components/typography'

import ResultsListItem from './components/ResultsListItem'

import './HowToResultsTablet.scss'

const RESULTS_DIR = 'results'
const LIGHT = 'light'

/**
 * HowToResultsTablet — component for result block for How it works page
 *
 * (for tablet and bigger sizes)
 */
class HowToResultsTablet extends ComponentSwitcher {
  render() {
    const { active } = this.state
    const {
      pathCdn,
      data,
      content,
      isWhiteArrow,
      separatorColor,
      isLast,
      textColor,
    } = this.props
    const path = `${pathCdn}/${RESULTS_DIR}/${data[active].image}`

    return (
      <>
        <div className="row pb-2">
          <div className="col-8 col-lg-5">
            <Text
              className={cs(
                { 'text--muted': textColor !== LIGHT },
                'how-to-results-tablet__text-over-square',
              )}
              dangerouslySetInnerHTML={{
                __html: content,
              }}
            />
          </div>
        </div>
        <div className="row how-to-results-tablet__wrapper">
          <div
            className={cs({
              'offset-1 col-md-3': !isLast,
              'col-4': isLast,
            })}
          >
            {data.map((item, index) => (
              <ResultsListItem
                key={index}
                icon={item.icon}
                title={item.title}
                isActive={index === active}
                onClick={() => this.handleClick(index)}
                {...{ separatorColor, isWhiteArrow }}
              />
            ))}
          </div>
          <div className="col-8">
            <div className="how-to-results-tablet__frame-wrapper">
              <FrameMacStraight
                className="how-to-results-tablet__frame"
                src={path}
                alt={data[active].image}
              />
            </div>
          </div>
        </div>
      </>
    )
  }
}

HowToResultsTablet.propTypes = {
  /** Text with description for this block */
  content: PropTypes.string.isRequired,

  /** Array of data */
  data: PropTypes.array.isRequired,

  /** Path to a directory with page's files */
  pathCdn: PropTypes.string.isRequired,

  /** Flag to set white color for arrow */
  isWhiteArrow: PropTypes.bool,

  /** Separator color */
  separatorColor: PropTypes.string,

  /** Is last block */
  isLast: PropTypes.bool,

  /** Text color */
  textColor: PropTypes.string,
}

export default HowToResultsTablet
